import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const UPDATE_GAME_MUTATION = gql`
	mutation($gameID: ID!, $data: JSON!, $playerID: String, $sessionID: String) {
		updateGame(
			gameID: $gameID
			data: $data
			playerID: $playerID
			sessionID: $sessionID
		) {
			id
			player {
				id
			}
			session {
				id
			}
			data
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={UPDATE_GAME_MUTATION} refetchQueries={['adminQuery', 'sessionQuery']}>
		{updateGame => Propagator(children, updateGame)}
	</Mutation>
);
